<template>
	<el-dialog :title="`${title}`" width="840px" :visible.sync="batchAddshow" :close-on-click-modal="false" 
		:append-to-body="true">
		<div style="margin-bottom: 10px;">{{$t('main.CurrentTopic')}} : {{ question.questionsName }}</div>
		<div style="max-width: 1100px; overflow-x: auto;">
			<table>
				<tr>
					<th class="td_width">{{$t('main.ColumnHeader')}}</th>
					<th class="td_width">{{$t('main.ValidateProperties')}}</th>
					<th class="td_width">{{$t('main.Range')}}</th>
				</tr>
				<tr v-for="item in question.questionsSonList[0].optionList" :key="item.SonId">
					<td class="td_width">
						<div class="table-th">
							<template>
								<span v-html="item.labelName"></span>
							</template>
						</div>
					</td>
					<td class="td_width" style="text-align: center">
						<el-select size="mini" v-model="item.type" :placeholder="$t('main.PleaseSelect')" @change="formatChange(item)">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</td>
					<td class="td_width" style="text-align: center">
						<div v-if="item.type == '3'">
							保留小数 :
							<el-select v-model="item.decimalPlaces" placeholder="请选择" size="mini" style="width: 80px">
								<el-option v-for="item in 6" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
							</el-select>
							{{$t('main.minimumValue')}} :
							<el-input-number size="mini" style="width: 80px;" v-model="item.minNum" :controls="false"></el-input-number>
							{{$t('main.MaximumValue')}} :
							<el-input-number size="mini" style="width: 80px;" v-model="item.maxNum" :controls="false"></el-input-number>
						</div>
						<div v-else-if="item.type == '1' || item.type == '2' || item.type == '24'">
							{{$t('main.MinimumWordCount')}} :
							<el-input-number size="mini" style="width: 80px;" v-model="item.minNum" :controls="false"></el-input-number>
							{{$t('main.MaximumWordCount')}} :
							<el-input-number size="mini" style="width: 80px;" v-model="item.maxNum" :controls="false"></el-input-number>
						</div>
						<div v-else-if="item.type == '10'"><el-input size="mini" v-model="item.optionName" style="margin-right: 10px;"></el-input></div>
						<div v-else></div>
					</td>
				</tr>
			</table>
		</div>
		<span slot="footer" class="dialog-footer">
			<!-- <el-button @click="cancelAdd">取 消</el-button> -->
			<el-button size="small" type="primary" @click="batchAdd" :loading="loading">{{$t('main.ok2')}}</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { v1 as UUID } from 'uuid';
export default {
	// 批量添加选项、行、列
	name: 'SetColumnProperties',
	props: {
		title: {
			type: String,
			default: ''
		},
		functionName: {
			type: String,
			default: ''
		},
		question: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			batchAddshow: false,
			addBatch: '',
			loading: false,
			placeholder: '',
			defaultOptionList: [],
			options: [
				{
					value: '1',
					label: this.$t('main.MultilineText')
				},
				{
					value: '2',
					label: this.$t('main.SingleLineText')
				},
				{
					value: '3',
					label: '数字'
				},
				// {
				// 	value: '5',
				// 	label: '日期'
				// },
				{
					value: '6',
					label: this.$t('main.cellPhoneNumber')
				},
				{
					value: '7',
					label: this.$t('main.FixedLine')
				},
				// {
				// 	value: '8',
				// 	label: '手机或固话'
				// },
				{
					value: '9',
					label: this.$t('main.Email')
				},
				{
					value: '10',
					label: this.$t('main.DropdownOptions')
				},
				// {
				// 	value: '11',
				// 	label: '多级下拉'
				// },
				{
					value: '12',
					label: this.$t('main.FileUpload')
				},
				// {
				// 	value: '13',
				// 	label: '国家及地区'
				// },
				// {
				// 	value: '14',
				// 	label: '省份城市'
				// },
				// {
				// 	value: '15',
				// 	label: '省市区'
				// },
				// {
				// 	value: '16',
				// 	label: '高校'
				// },
				// {
				// 	value: '17',
				// 	label: '地图'
				// },
				{
					value: '18',
					label: this.$t('main.Url')
				},
				{
					value: '19',
					label: this.$t('main.ID')
				},
				// {
				// 	value: '20',
				// 	label: '学号'
				// },
				// {
				// 	value: '21',
				// 	label: 'QQ'
				// },
				// {
				// 	value: '22',
				// 	label: '汉字'
				// },
				// {
				// 	value: '23',
				// 	label: '中文姓名'
				// },
				{
					value: '24',
					label: this.$t('main.English')
				}
				// {
				// 	value: '25',
				// 	label: '英文数字'
				// },
			]
		};
	},
	created() {
		console.log('this.qu$for stion', this.question);
	},
	methods: {
		// 填空选项内容限制
        formatChange(e) {
            if(e.type != 3) {
                e.decimalPlaces = 0
                if (e.minNum < 0)  e.minNum = 0
                if ( e.maxNum < 0) e.maxNum = 0
            }
        },
		cancelAdd() {
			this.addBatch = '';
			this.batchAddshow = false;
			this.loading = false;
			this.defaultOptionList = [];
			this.placeholder = '';
		},
		batchAdd() {
			this.loading = true;
			// let optionArr = this.addBatch.split('\n').filter(info => info);
			console.log('question', this.question.questionsSonList);
			// this.question.questionsSonList[0].optionList.forEach(item=>{
			// 判断选项是否为下拉 根据输入值渲染下拉列表
			this.question.questionsSonList.forEach((item2, index2) => {
				item2.optionList = this.question.questionsSonList[0].optionList
				item2.optionList.forEach((item3) => {
					if(item3.type=='10'){
						let options = []
						item3.options = []
						options = item3.optionName.split(';')
						options.forEach(optionsEve=>{
							let obj = {
								value : UUID(),
								label : optionsEve
							}
							item3.options.push(obj)
						})
					}
				});
			});
			// })
			console.log('完成', this.question.questionsSonList);
			// this.$emit('addColumnProperties', optionArr);
			// this.delOption();
			this.cancelAdd();
		},
		delOption() {
			if (this.defaultOptionList.length > 0) {
				switch (this.functionName) {
					case 'batchAdd': // 删除选项
						this.question.optionList = this.question.optionList.filter(info => !info.isDefault);
						break;
					case 'batchAddRows': // 删除行
						this.question.questionsSonList = this.question.questionsSonList.filter(info => !info.isDefault);
						console.log(this.question.questionsSonList);
						break;
					case 'batchAddColumns': // 删除列
						this.question.questionsSonList.forEach(son => {
							son.optionList = son.optionList.filter(info => !info.isDefault);
						});
						break;
				}
			}
		}
	}
};
</script>
<style scoped lang="scss">
/deep/ .textval {
	border: 1px solid #ccc !important;
	width: 120px;
	height: 20px;
	margin: 0 auto;
}
table,
table td,
table th {
	border: 1px solid #ccc;
	border-collapse: collapse;
	font-weight: normal;
}
tr {
	height: 30px;
}
.td_width {
	text-align: center;
	padding: 10px 20px;
}
.el-dropdown-link {
	cursor: pointer;
	color: #409eff;
	display: inline-block;
	margin-top: 5px;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.delete,
.item {
	font-size: 22px !important;
	line-height: 40px !important;
	margin-right: 30px !important;
	text-align: right;
	float: right;
	cursor: pointer;
}
.item .el-badge__content.is-fixed {
	top: 10px;
}
.item.drag-handle {
	cursor: move;
}
.el_item_option {
	line-height: 40px;
	// height: 44px;
}

.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.item_container_title {
	padding-left: 0px !important;
	padding-right: 0px !important;
}

/deep/.el-textarea .el-textarea__inner {
	border: 1px solid #dcdfe6 !important;
	background-color: #fff;
}
.table-th {
	display: flex;
	justify-content: center;
}
</style>
